var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { createRef, forwardRef, memo } from "react";
import { usePresentationComponent } from "../../../AppContext";
import get from "lodash/get";
import keyBy from "lodash/keyBy";
import useFieldApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-field-api";
import { getClassName } from "../../../helpers";
import { INPUT_GROUP, SEARCH_SELECT_GROUP_HEADER, SEARCH_SELECT_OPTION, SEARCH_SELECT_OPTION_DISABLED, SEARCH_SELECT_SEARCH_INPUT, SEARCH_SELECT_SEARCH_QUERY_CONTAINER, SEARCH_SELECT_SEARCH_QUERY_INPUT, SEARCH_SELECT_SEARCH_OPTIONS } from "../../../classConstants";
import { useDispatch } from "react-redux";
import useFormApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-form-api";
import { getSearchAndSelectName } from "../../BookingForm/booking-form.helpers";
import { Input } from "../Input/Input";
import parse from 'html-react-parser';
import styled from 'styled-components';
import i18next from "i18next";
import keys from "lodash/keys";
import { Spinner } from "../../Spinner";
import { Select, } from "../Select/Select";
import { SvgIcon } from "../../../icons";
var buildOptionsGroups = function (options, value, emptyOptionLabel) {
    var _a;
    if (emptyOptionLabel)
        options = __spreadArray([{ key: 'default_value', value: "", label: emptyOptionLabel }], (options !== null && options !== void 0 ? options : []));
    return (_a = options === null || options === void 0 ? void 0 : options.reduce(function (flat, option) {
        if (!option.children) {
            return option.value !== value ? flat.concat(option) : flat;
        }
        var children = option.children.map(function (x) { return (__assign(__assign({}, x), { isGroupedOption: true })); }).filter(function (x) { return x.value !== value; });
        if (!children.length)
            return flat;
        flat.push(__assign(__assign({}, option), { disabled: true, isGroupHeader: true }));
        return flat.concat(children);
    }, [])) !== null && _a !== void 0 ? _a : [];
};
var SearchAndSelectOption = /** @class */ (function (_super) {
    __extends(SearchAndSelectOption, _super);
    function SearchAndSelectOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var _a, _b;
            if (_this.props.disabled)
                return;
            if (_this.props.isGroupHeader)
                return;
            (_b = (_a = _this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, _this.props.value);
        };
        return _this;
    }
    SearchAndSelectOption.prototype.render = function () {
        var _a;
        return (React.createElement(Option, { onClick: this.onClick, className: getClassName(SEARCH_SELECT_OPTION, (_a = {},
                _a[SEARCH_SELECT_OPTION_DISABLED] = this.props.disabled && !this.props.isGroupHeader,
                _a[SEARCH_SELECT_GROUP_HEADER] = this.props.isGroupHeader,
                _a)) }, parse(this.props.label)));
    };
    return SearchAndSelectOption;
}(React.PureComponent));
var getResetProps = function (reset, state, name, event) {
    switch (typeof reset) {
        case "function": return reset(state, name, event);
        case "object": return reset;
        default: return {};
    }
};
var deriveDisplayValue = function (options, value) {
    var _a;
    var values = keyBy(buildOptionsGroups(options, '', ''), "value");
    if (!values[value]) {
        return "";
    }
    return (_a = get(values, value + ".displayTitle", get(values, value + ".label"))) === null || _a === void 0 ? void 0 : _a.trim();
};
var LoadMoreRenderer = memo(forwardRef(function (props, ref) {
    if (!props.loadMore)
        return null;
    return React.createElement("div", { ref: ref });
}));
var DefaultRenderer = /** @class */ (function (_super) {
    __extends(DefaultRenderer, _super);
    function DefaultRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.acRef = React.createRef();
        _this.state = {
            show: false,
            query: _this.props.query,
            selectedOption: [],
        };
        _this.node = null;
        _this.observer = null;
        _this.loadMoreRef = createRef();
        _this.showOptions = function (e) {
            var _a;
            (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
            _this.setState({ show: true });
        };
        _this.hideOptions = function (e) {
            var _a;
            if ((_a = _this.acRef.current) === null || _a === void 0 ? void 0 : _a.contains(e === null || e === void 0 ? void 0 : e.target)) {
                return;
            }
            if (!_this.acRef.current) {
                document.removeEventListener("click", _this.hideOptions);
                _this.clearObserver();
                return;
            }
            _this.setState({ show: false });
        };
        _this.onTextUpdate = function (event) {
            var _a, _b;
            var query = event.target.value;
            _this.setState({ query: query });
            (_b = (_a = _this.props).onQueryChange) === null || _b === void 0 ? void 0 : _b.call(_a, query);
            _this.props.fetchOptions(query);
        };
        _this.handleSelect = function (value) {
            _this.props.onChange(value);
            _this.hideOptions();
        };
        _this.setTop = function (node) {
            if (!_this.props.loadMore)
                return;
            _this.observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    var _a, _b;
                    if (!entry.isIntersecting)
                        return;
                    return (_b = (_a = _this.props).loadMore) === null || _b === void 0 ? void 0 : _b.call(_a);
                });
            }, {
                root: node,
                rootMargin: "0px",
                threshold: 1.0,
            });
            _this.observer.observe(_this.loadMoreRef.current);
        };
        _this.onValueChange = function () { };
        return _this;
    }
    DefaultRenderer.prototype.getDisplayValue = function () {
        return deriveDisplayValue(this.props.options, this.props.value);
    };
    DefaultRenderer.getDerivedStateFromProps = function (nextProps, state) {
        var _a;
        if ((nextProps.value || '') === (((_a = state.selectedOption[0]) === null || _a === void 0 ? void 0 : _a.value) || ''))
            return {};
        var label = deriveDisplayValue(nextProps.options, nextProps.value);
        if (!nextProps.value || !label) {
            return {
                selectedOption: [{
                        value: nextProps.value,
                        label: label,
                    }]
            };
        }
        return {
            selectedOption: [{
                    value: nextProps.value,
                    label: label,
                }]
        };
    };
    DefaultRenderer.prototype.componentDidUpdate = function (prevProps, state) {
        if (!this.observer)
            this.clearObserver();
        if (!this.node)
            return;
        if (!this.state.show)
            return;
        if (prevProps.options.length === this.props.options.length)
            return;
        this.setTop(this.node);
    };
    DefaultRenderer.prototype.componentDidMount = function () {
        this.props.value && this.props.fetchOptions("");
        document.addEventListener("click", this.hideOptions);
    };
    DefaultRenderer.prototype.loadMore = function () {
        var _this = this;
        if (!this.props.loadMore)
            return;
        if (!this.props.loading) {
            return this.props.loadMore();
        }
        this.requestAnimationFrameToken = requestAnimationFrame(function () {
            var _a, _b;
            if (_this.props.loading)
                return;
            cancelAnimationFrame(_this.requestAnimationFrameToken);
            (_b = (_a = _this.props).loadMore) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
        return;
    };
    DefaultRenderer.prototype.clearObserver = function () {
        if (this.requestAnimationFrameToken) {
            cancelAnimationFrame(this.requestAnimationFrameToken);
        }
    };
    DefaultRenderer.prototype.renderOptions = function () {
        var _this = this;
        if (!this.state.show)
            return null;
        var _a = this.props, options = _a.options, name = _a.name;
        return (React.createElement(OptionPopover, { ref: this.setTop, className: SEARCH_SELECT_SEARCH_OPTIONS },
            React.createElement(Input, { autoFocus: true, type: "text", name: name + "-search", inputClassName: getClassName(SEARCH_SELECT_SEARCH_QUERY_INPUT, "unstyled"), className: SEARCH_SELECT_SEARCH_QUERY_CONTAINER, placeholder: i18next.t("search"), onChange: this.onTextUpdate, value: this.state.query || '', leftIcon: React.createElement(SvgIcon, { type: "search" }) }),
            React.createElement(OptionList, null,
                buildOptionsGroups(options, this.props.value, this.props.showDefaultOption ? this.props.placeholder || i18next.t('common.select', { label: this.props.label }) : '').map(function (_a, i) {
                    var key = _a.key, value = _a.value, label = _a.label, isGroupHeader = _a.isGroupHeader, disabled = _a.disabled;
                    return React.createElement(SearchAndSelectOption, { key: key !== null && key !== void 0 ? key : value, label: label, value: value, isGroupHeader: isGroupHeader, disabled: disabled, onClick: isGroupHeader ? undefined : _this.handleSelect });
                }),
                React.createElement(LoadMoreRenderer, { loadMore: this.props.loadMore, ref: this.loadMoreRef }))));
    };
    DefaultRenderer.prototype.render = function () {
        var _a = this.props, meta = _a.meta, className = _a.className, name = _a.name, value = _a.value, label = _a.label, placeholder = _a.placeholder, loading = _a.loading, required = _a.required;
        return (React.createElement(AutoComplete, { ref: this.acRef, shown: this.state.show, className: getClassName(className, "ws-search-n-select-input-container"), onFocus: this.showOptions },
            React.createElement(Select, { hideOnNoOptions: !this.state.query, name: name, meta: meta, label: label, required: required, placeholder: placeholder, className: SEARCH_SELECT_SEARCH_INPUT, 
                // onChange={this.onValueChange}
                value: value, options: this.state.selectedOption }),
            this.renderOptions(),
            loading &&
                React.createElement(Spinner, null)));
    };
    return DefaultRenderer;
}(React.Component));
var AutoComplete = styled.div.attrs(function (props) { return ({
    shown: props["shown"]
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    --ws-input-margin: 0;\n    position: relative;\n    ", "\n"], ["\n    --ws-input-margin: 0;\n    position: relative;\n    ", "\n"])), function (_a) {
    var shown = _a.shown;
    return shown ? "z-index: 100;" : "";
});
var OptionPopover = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    border: 1px solid var(--ws-picker-border-color);\n    background: var(--ws-picker-bg);\n    color:  var(--ws-picker-bg-contrast);\n    overflow: auto;\n    max-height: calc(45vh - calc(var(--ws-picker-offset, 1em) * 2));\n\n    .", " {\n        position: sticky;\n        top: 0;\n        z-index: 1000;\n        padding: var(--ws-picker-padding, .5em);\n        background: var(--ws-picker-bg);\n\n        .", " {\n            padding-left: 2.7em !important;\n            border-radius: var(--ws-picker-search-border-radius, 10em);\n        }\n    }\n\n    .ws-svg-search {\n        position: absolute;\n        left: .6em;\n        height: calc(100% - .6em);\n        top: 50%;\n        transform: translateY(-50%);\n        color: currentColor;\n        width: 1em;\n    }\n"], ["\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    border: 1px solid var(--ws-picker-border-color);\n    background: var(--ws-picker-bg);\n    color:  var(--ws-picker-bg-contrast);\n    overflow: auto;\n    max-height: calc(45vh - calc(var(--ws-picker-offset, 1em) * 2));\n\n    .", " {\n        position: sticky;\n        top: 0;\n        z-index: 1000;\n        padding: var(--ws-picker-padding, .5em);\n        background: var(--ws-picker-bg);\n\n        .", " {\n            padding-left: 2.7em !important;\n            border-radius: var(--ws-picker-search-border-radius, 10em);\n        }\n    }\n\n    .ws-svg-search {\n        position: absolute;\n        left: .6em;\n        height: calc(100% - .6em);\n        top: 50%;\n        transform: translateY(-50%);\n        color: currentColor;\n        width: 1em;\n    }\n"])), SEARCH_SELECT_SEARCH_QUERY_CONTAINER, SEARCH_SELECT_SEARCH_QUERY_INPUT);
var OptionList = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: var(--ws-picker-padding, .5em);\n"], ["\n    padding: var(--ws-picker-padding, .5em);\n"])));
var Option = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: .5em;\n\n\n    &:not(:first-of-type) {\n        border-top: 1px solid var(--ws-picker-border-color);\n    }\n\n    &:not(.", "):not(.", ") {\n        cursor: pointer;\n        &:hover {\n            background-color: var(--ws-picker-option-hover-bg);\n            color: var(--ws-picker-option-hover-color);\n        }\n    }\n\n\n    &.", " {\n        background-color: var(--ws-picker-option-header-bg);\n        color: var(--ws-picker-option-header-bg-contrast);\n        font-weight: bold;\n        touch-action: none;\n        font-size: var(--ws-picker-option-header-size, .85em);\n        &:not(:first-child) {\n            margin-top: var(--ws-picker-option-header-offset, 1em);\n        }\n    }\n\n    &.", " {\n        background-color: var(--ws-picker-option-disabled-bg);\n        color: var(--ws-picker-option-disabled-bg-contrast);\n        opacity: var(--ws-picker-option-disabled, .4);\n        touch-action: none;\n        cursor: not-allowed;\n    }\n"], ["\n    padding: .5em;\n\n\n    &:not(:first-of-type) {\n        border-top: 1px solid var(--ws-picker-border-color);\n    }\n\n    &:not(.", "):not(.", ") {\n        cursor: pointer;\n        &:hover {\n            background-color: var(--ws-picker-option-hover-bg);\n            color: var(--ws-picker-option-hover-color);\n        }\n    }\n\n\n    &.", " {\n        background-color: var(--ws-picker-option-header-bg);\n        color: var(--ws-picker-option-header-bg-contrast);\n        font-weight: bold;\n        touch-action: none;\n        font-size: var(--ws-picker-option-header-size, .85em);\n        &:not(:first-child) {\n            margin-top: var(--ws-picker-option-header-offset, 1em);\n        }\n    }\n\n    &.", " {\n        background-color: var(--ws-picker-option-disabled-bg);\n        color: var(--ws-picker-option-disabled-bg-contrast);\n        opacity: var(--ws-picker-option-disabled, .4);\n        touch-action: none;\n        cursor: not-allowed;\n    }\n"])), SEARCH_SELECT_OPTION_DISABLED, SEARCH_SELECT_GROUP_HEADER, SEARCH_SELECT_GROUP_HEADER, SEARCH_SELECT_OPTION_DISABLED);
var searchNSelectFactory = function () {
    var SearchNSelect = function (props) {
        var isHidden = props.isHidden, labelKey = props.labelKey, meta = props.meta, valueKey = props.valueKey, name = props.name, value = props.value, className = props.className, label = props.label, options = props.options, isLoading = props.isLoading, allowBlank = props.allowBlank, hasRemoteSource = props.hasRemoteSource;
        var _a = React.useState(options), filteredOptions = _a[0], setFilterOptions = _a[1];
        var Component = usePresentationComponent("searchselect") || DefaultRenderer;
        var dispatch = useDispatch();
        var queryRef = React.useRef(props.query);
        React.useEffect(function () { return setFilterOptions(options); }, [options]);
        var fetchOptions = function (query) {
            if (query === void 0) { query = ""; }
            // Filter Results
            var dispatchProps = { query: query, options: options, labelKey: labelKey, valueKey: valueKey, name: name };
            var updatedOptions = props.isFetchOptionsDispatchAction ? dispatch(props.fetchOptions(dispatchProps)) : props.fetchOptions(dispatchProps);
            if (Array.isArray(updatedOptions))
                setFilterOptions(updatedOptions);
        };
        var onChange = fetchOptions ? function (event) {
            if (typeof event === "object") {
                event = event === null || event === void 0 ? void 0 : event.target.value;
            }
            if (event === value) {
                return;
            }
            if (event === null) {
                fetchOptions(event);
            }
            props.onChange(event);
        } : props.onChange;
        var componentProps = {
            fetchOptions: fetchOptions,
            name: name,
            value: value,
            className: className,
            label: label,
            meta: meta,
            allowBlank: allowBlank,
            query: props.query,
            options: filteredOptions,
            loading: !!isLoading,
            isLoading: !!isLoading,
            labelKey: labelKey, valueKey: valueKey,
            hasRemoteSource: hasRemoteSource,
            onChange: onChange,
            required: props.required,
            placeholder: props.placeholder,
            onQueryChange: props.onQueryChange,
            loadMore: props.loadMore,
            showDefaultOption: props.showDefaultOption,
        };
        if (isHidden)
            return React.createElement("input", { type: "hidden", onChange: onChange, value: value });
        return (React.createElement("div", { className: getClassName(INPUT_GROUP) },
            React.createElement(Component, __assign({}, componentProps))));
    };
    SearchNSelect.defaultProps = {
        labelKey: "title",
        valueKey: "value",
        onQueryChange: function (query) { },
        fetchOptions: function (_a) {
            var _b = _a.options, options = _b === void 0 ? [] : _b, query = _a.query, _c = _a.labelKey, labelKey = _c === void 0 ? "" : _c;
            return options.filter(function (x) { return get(x, labelKey, "").toLowerCase().includes(query); });
        }
    };
    return SearchNSelect;
};
export var SearchNSelect = searchNSelectFactory();
export var ReactiveSearchNSelect = function (props) {
    var _a = useFieldApi(props), input = _a.input, getDynamicValue = _a.getDynamicValue, reset = _a.reset, meta = _a.meta;
    var formOptions = useFormApi();
    var state = formOptions.getState().values;
    if (getDynamicValue) {
        var onChange_1 = input.onChange;
        input.onChange = function (x) {
            var obj = getDynamicValue(x.currentTarget, state);
            var fields = [].concat(obj);
            formOptions.change("skip", true);
            fields.forEach(function (_a) {
                var key = _a.key, value = _a.value;
                if (key) {
                    formOptions.change(key, value);
                }
                ;
            });
            if (!fields.some(function (field) { return get(field, "key") === (input === null || input === void 0 ? void 0 : input.name); })) {
                onChange_1(x);
            }
            formOptions.change("skip", undefined);
        };
    }
    if (reset) {
        // const onChange = input.onChange;
        input.onChange = function (event) {
            var resetProps = getResetProps(reset, state, props.name, event);
            formOptions.batch(function () {
                formOptions.change("skip", true);
                formOptions.change(props.name, event);
                keys(resetProps).forEach(function (key) { return formOptions.change(key, resetProps[key]); });
                formOptions.change("skip", undefined);
            });
        };
    }
    var onQueryChange = React.useCallback(function (query) {
        var _a;
        formOptions.change(getSearchAndSelectName(props.name), query);
        (_a = props.onQueryChange) === null || _a === void 0 ? void 0 : _a.call(props, query);
    }, []);
    return React.createElement(SearchNSelect, __assign({}, props, input, { onQueryChange: onQueryChange, meta: meta }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
